export const MOBILE_SHEET_DURATION_MS = 240;
export const MOBILE_SHEET_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
